import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'clsx';
import style from './style.module.scss';
import { useTranslation } from '@hooks/index';

const ClearFiltersIcon = ({ appliedFilters }: { appliedFilters: number }) => {
    const { t } = useTranslation();

    return (
        <div className={cn('k-d-flex', { [style.active]: !!appliedFilters })}>
            {!!appliedFilters && (
                <div className={style.text}>
                    ({`${appliedFilters} ${appliedFilters === 1 ? t('grid.activeFilter') : t('grid.activeFilters')}`})
                </div>
            )}
            <FontAwesomeIcon
                aria-label={`${t('clearFilters')}`}
                icon={['far', 'filter-slash']}
                style={{ fontSize: 18 }}
            />
        </div>
    );
};

export default ClearFiltersIcon;
